import ListBox from "../components/ListBox";
import Header from "../components/Header";
import QuestionInput from "../components/QuestionInput";
import NavBar from "./NavBar";
import {
  Button,
  Box,
  Container,
  Tooltip,
  ScaleFade,
} from "@chakra-ui/react";
import QuestionList from "../components/QuestionList";
import { useState } from "react";
import axios from "axios";
import { useRedirectToLogin } from "../lib/hooks";
import Paywall from "./accounts/Paywall";
import { useAccount } from "../lib/accountContext";
import LoadingPage from "./LoadingPage";
import toast, { Toaster } from 'react-hot-toast';

// Sets isSubscribed to true for everyone if ENABLE_PAYWALL is set to false
const ENABLE_PAYWALL = false;

const Generator = (props) => {
  const account = useAccount();

  useRedirectToLogin();

  const [questions, setQuestions] = useState([]);
  const [isAPIPending, setAPIPending] = useState(false);

  const [generatorInput, setGeneratorInput] = useState("");
  const [secondGeneratorInput, setSecondGeneratorInput] = useState("");

  const [listSelection, setListSelection] = useState("");
  const [secondListSelection, setSecondListSelection] = useState("");

  const { generatorData } = props;

  // get questions from OpenAI API
  const getQuestions = async () => {
    setAPIPending(true);
    setQuestions([]);

    const response = await fetch(axios.defaults.baseURL + generatorData.api, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...axios.defaults.headers,
      },
      body: JSON.stringify({
        input: generatorInput,
        secondInput: secondGeneratorInput,
        option: generatorData?.select?.options.filter(
          (option) => option.value === listSelection
        )[0].label,
        secondOption: secondListSelection || undefined,
      }),
    }).catch((error) => {
      toast.error("Sorry, there was an issue retrieving the items. We are working on it.");
    });
    if (!response.ok) {
      toast.error("Sorry, there was an issue retrieving the items. We are working on it.");
      setAPIPending(false);
      return;
    }

    const data = response.body;
    if (!data) {
      return;
    }

    const reader = data.getReader();
    const decoder = new TextDecoder();
    setAPIPending(false);

    let done = false;
    while (!done) {
      const { value, done: doneReading } = await reader.read();
      done = doneReading;
      const chunkValue = decoder.decode(value);

      if (chunkValue !== undefined) {
        setQuestions((prev) => [
          (prev[0] !== undefined ? prev[0] : "") + chunkValue,
        ]);
      }
    }

    setAPIPending(false);
  };

  const isSubscribed = ENABLE_PAYWALL ? account.isSubscribed : true;

  return isSubscribed === false ? (
    <Paywall />
  ) : (
    <Box mb="10">
      <NavBar />
      <Header title={generatorData.title} />
      {!isSubscribed ? (
        <LoadingPage />
      ) : (
        <>
          <ScaleFade initialScale={0.9} in={true} delay={0.1}>
            <QuestionInput
              label={generatorData.topic.label}
              placeholder={generatorData.topic.placeholder}
              generatorInput={generatorInput}
              setGeneratorInput={setGeneratorInput}
              helperItems={generatorData.topic.helperItems}
            />
          </ScaleFade>
          <ScaleFade initialScale={0.7} in={true} delay={0.15}>
            {generatorData.secondTopic && (
              <QuestionInput
                label={generatorData.secondTopic.label}
                placeholder={generatorData.secondTopic.placeholder}
                generatorInput={secondGeneratorInput}
                setGeneratorInput={setSecondGeneratorInput}
                helperItems={generatorData.secondTopic.helperItems}
              />
            )}
          </ScaleFade>
          <ScaleFade initialScale={0.7} in={true} delay={0.2}>
            {generatorData.select && (
              <ListBox
                listSelection={listSelection}
                setListSelection={setListSelection}
                select={generatorData.select}
              />
            )}
          </ScaleFade>
          <ScaleFade initialScale={0.7} in={true} delay={0.25}>
            {generatorData.secondSelect && (
              <Box mt="8">
                <ListBox
                  listSelection={secondListSelection}
                  setListSelection={setSecondListSelection}
                  select={generatorData.secondSelect}
                />
              </Box>
            )}
          </ScaleFade>
          <Container>
            <Tooltip
              label="Please add at least 30 characters."
              isDisabled={
                generatorInput.length >=
                (generatorData.topic.minCharacters || 30)
              }
              placement="bottom"
            >
              <Button
                marginTop="10"
                onClick={getQuestions}
                isLoading={isAPIPending}
                colorScheme="purple"
                width="100%"
                isDisabled={
                  generatorInput.length <
                  (generatorData.topic.minCharacters || 0)
                }
              >
                {generatorData.buttonLabel}
              </Button>
            </Tooltip>
          </Container>
        </>
      )}
      <QuestionList questions={questions} generatorId={generatorData.id} />
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
    </Box>
  );
};

export default Generator;
